import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allVulnTemplatesAreSelected, someVulnTemplateIsSelected } from 'store/KnowledgeBase/selectors';
import SelectionHeader from 'shared/ui/Table/cells/SelectionHeader';
import { selectAllTemplate } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';

export const CheckHeader = () => { // eslint-disable-line import/prefer-default-export
  const allTemplateSelected = useSelector(allVulnTemplatesAreSelected);
  const someTemplateSelected = useSelector(someVulnTemplateIsSelected);
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(selectAllTemplate());
  };

  return (
    <SelectionHeader onChange={ handleClick } checked={ allTemplateSelected } indeterminate={ someTemplateSelected && !allTemplateSelected } />
  );
};
